export default __webpack_public_path__ + "static/media/8.da131095.png";